export function registerStateKey(stateKey: string) {
  const isDevelopmentBuild = import.meta.env.MODE === 'development';
  if (isDevelopmentBuild) {
    console.log('[DEV] Registering statekey in FullStory', stateKey);
    return;
  }

  window.FS?.identify(stateKey, { stateKey_str: stateKey });
}
